import { EmptyResultsFiltersPlaceholder } from '@servicetitan/cp-ui';
import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { FC, Fragment } from 'react';
import { EstimateContainerWebModel } from '../../../api/portal-dashboard.api';
import { ProposalDrawerStore } from '../../../stores/proposal-drawer.store';
import { ProposalDrawer } from './proposal-drawer/proposal-drawer';
import { ProposalsListItem } from './proposals-list-item';

interface ProposalsListProps {
    filtered: boolean;
    proposals?: EstimateContainerWebModel[];
    resetFilters(): void;
}

export const ProposalsList: FC<ProposalsListProps> = observer(props => {
    const { filtered, proposals, resetFilters } = props;

    const [drawerStore] = useDependencies(ProposalDrawerStore);

    const handleViewEstimatesClick = (proposalId: string) => {
        drawerStore.open(proposalId);
    };

    return (
        <Fragment>
            <ProposalDrawer />

            {!proposals?.length && (
                <EmptyResultsFiltersPlaceholder
                    title="No proposal records found"
                    showFilterButtons={filtered}
                    onClearFiltersClick={resetFilters}
                    size="small"
                />
            )}

            {!!proposals && proposals?.length > 0 && (
                <div className="m-b--2">
                    {proposals.map(proposal => (
                        <ProposalsListItem
                            key={proposal.id}
                            className="m-b-2"
                            proposal={proposal}
                            onViewEstimatesClick={handleViewEstimatesClick}
                        />
                    ))}
                </div>
            )}
        </Fragment>
    );
});
